<script>
  import { format } from 'svelte-i18n';

  import { PUSH_ACTION_COLORS } from '@client/enums';
</script>

<ul class="d-flex mt-2 text-muted">
  <li class="me-3">
    <span style="color: #{PUSH_ACTION_COLORS['bizcard']}">●</span>
    <small>{$format('label.BUSINESS_CARD')}</small>
  </li>
</ul>
